exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabview {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    list-style: none;\n    -webkit-padding-start: 0px;\n    width: 100%;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n.tabview_tab {\n    text-align: center;\n    padding: 10px;\n    margin: 5px;\n    background: #607D8B;\n    color: white;\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n    border: 0 none;\n    cursor: pointer;\n    border-radius: 3px;\n    box-shadow: 0 1px 2.5px 0 rgba(0, 0, 0, 0.26), 0 1px 5px 0 rgba(0, 0, 0, 0.16);\n}\n\n.tabview_tab a {\n    color: white;\n}\n\n.tabview_tab.active {\n    background-color: #F6BD60;\n    transition: 0.3s\n}\n\n.tabview_tab.active a {\n    color: #212121;\n}\n\n.tab-close {\n    color: gray;\n    text-align: right;\n    cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/locales/locales.component.css
// module id = ../../../../../src/app/components/organization/captive-portal/locales/locales.component.css
// module chunks = main